










































































































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { Cycle } from '@/api/cycles';
import { Product, QualRewardGroup, Qualifier } from '@/api/product';
import { QualificationTypes, QualificationType, QualOverrideResource } from '@/api/qualoverride';
import CycleSelect from '@/components/cycles/CycleSelect.vue';
import ProductSelect from '@/components/products/ProductSelect.vue';


@Component({
  computed: mapState(['fiId']),
  components: { CycleSelect, ProductSelect },
})
export default class QualificationOverrideCard extends Vue {
  fiId!: string;

  selectedCycle: Cycle | null = null;

  loading: boolean = true;

  saving: boolean = false;

  selectedProduct: Product | null = null;

  overrideForAllAccounts: boolean | null = null;

  accountNumberText: string = '';

  overallQualification: boolean | null = null;

  qualificationTypesForProduct: QualificationType[] = [];

  selectedQualificationType: QualificationType | null = null;

  overrideLevelsForProduct: number[] = [];

  selectedOverrideLevel: number | null = null;

  static readonly ALL_PRODUCTS_ID: number = -1;

  @Inject('QualOverrideResource')
  qualOverrideResource!: QualOverrideResource;

  @Watch('selectedProduct')
  onNewProduct() {
    this.populateQualificationTypesForProduct();
    this.populateOverrideLevelsForProduct();
  }

  populateQualificationTypesForProduct() {
    this.qualificationTypesForProduct = [];
    this.selectedQualificationType = null;

    if (this.selectedProduct && this.selectedProduct.id !== QualificationOverrideCard.ALL_PRODUCTS_ID) {
      const qualRewardGroups: QualRewardGroup[] = this.selectedProduct.qualRewardGroups;

      qualRewardGroups.forEach((group: QualRewardGroup) => {
        const qualifiersForCurrentGroup: Qualifier[] = group.qualifiers;
        if (qualifiersForCurrentGroup) {
          qualifiersForCurrentGroup.forEach((qualifier: Qualifier) => {
            const qualType: QualificationType | null = QualificationOverrideCard.getQualificationTypeForProductQualRewardQualifier(qualifier);
            if (qualType !== null && !this.qualificationTypesForProduct.includes(qualType)) {
              this.qualificationTypesForProduct.push(qualType);
            }
          });
        }
      });
    }
    this.qualificationTypesForProduct = this.qualificationTypesForProduct.sort();
  }

  static getQualificationTypeForProductQualRewardQualifier(qualifier: Qualifier): QualificationType | null {
    let foundQualType: QualificationType | null = null;
    QualificationTypes.forEach((qualType: QualificationType, key: string) => {
      if (QualificationOverrideCard.isQualificationTypesClassMatch(qualType, qualifier)
        && (QualificationOverrideCard.hasNoTransactionTypeField(qualifier) || QualificationOverrideCard.transactionTypeFieldsMatch(qualType, qualifier))) {
        foundQualType = qualType;
      }
    });
    return foundQualType;
  }

  static isQualificationTypesClassMatch(qualType: QualificationType, qualifier: Qualifier): boolean {
    /* eslint-disable no-underscore-dangle */
    return qualType._class === qualifier._class;
    /* eslint-enable no-underscore-dangle */
  }

  static hasNoTransactionTypeField(qualifier: Qualifier): boolean {
    return qualifier.transactionType === undefined;
  }

  static transactionTypeFieldsMatch(qualType: QualificationType, qualifier: Qualifier): boolean {
    return qualType.transactionType === qualifier.transactionType;
  }

  populateOverrideLevelsForProduct() {
    this.overrideLevelsForProduct = [];
    this.selectedOverrideLevel = null;
    if (this.selectedProduct) {
      if (this.selectedProduct.id === QualificationOverrideCard.ALL_PRODUCTS_ID) {
        this.overrideLevelsForProduct.push(1);
      } else {
        this.selectedProduct.qualRewardGroups.forEach((group: QualRewardGroup) => {
          if (group.level !== 0) {
            this.overrideLevelsForProduct.push(group.level);
          }
        });
      }
    }

    if (this.overrideLevelsForProduct.length === 1) {
      this.selectedOverrideLevel = this.overrideLevelsForProduct[0];
    }
  }

  onSave() {
    if (this.selectedCycle && this.selectedProduct && this.selectedOverrideLevel) {
      this.saving = true;
      this.qualOverrideResource.createQualOverride(this.fiId, this.selectedCycle, this.selectedProduct.productMapping.externalProductMappingId,
        this.selectedProduct.id === QualificationOverrideCard.ALL_PRODUCTS_ID, this.overrideForAllAccounts, this.accountNumberText,
        this.overallQualification, this.selectedQualificationType, this.selectedOverrideLevel)
        .then((result: any) => {
          const al = new Alert('Qualification override created.', NoticeClass.SUCCESS);
          al.setTimeout(5000);
          this.$store.dispatch('notices/add', al);
          this.$emit('save');
        })
        .catch((error: any) => {
          console.dir(error);
          if (error.response && error.response.status === 409) {
            this.showErrorMessage('A conflicting qualification override already exists.');
          } else {
            this.showErrorMessage(error);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  accountNumberTextUpdated() {
    this.accountNumberText = this.accountNumberText.replace(/,/g, '\n');
    this.accountNumberText = this.accountNumberText.replace(/ /g, '\n');
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
